<section *ngIf="embedded; else framed" class="audit-activity audit-activity--embedded" [attr.aria-label]="title">
  <div *hearingPhaseBar="'actions'">
    <ui-button buttonText="Refresh activity" severity="secondary" [disabled]="isLoading()" (click)="load()"></ui-button>
  </div>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</section>
<ng-template #framed>
  <ui-panel class="audit-activity" width="fill" [panelTitle]="title" [title]="title">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ui-panel>
</ng-template>
<ng-template #content>
  <div *ngIf="isLoading()" class="state loading" data-testid="audit-loading">
    Loading audit activity
  </div>

  <div *ngIf="!isLoading() && errorState() as error" class="state error" role="alert" data-testid="audit-error">
    <strong>{{ error.title }}</strong>
    <p *ngFor="let message of error.messages" class="message">{{ message }}</p>
    <ui-button *ngIf="!embedded" buttonText="Retry activity" severity="secondary" (click)="load()"></ui-button>
  </div>

  <ng-container *ngIf="!isLoading() && !errorState()">
    <p *ngIf="entries().length === 0" class="message" data-testid="audit-empty">
      {{ emptyMessage }}
    </p>

    <ol *ngIf="entries().length > 0" class="audit-activity__entries" data-testid="audit-list">
      <li *ngFor="let entry of entries(); trackBy: trackByEntry" class="audit-activity__entry">
        <div class="audit-activity__entry-header">
          <span class="audit-activity__summary">{{ entry.summary }}</span>
          <time class="audit-activity__when" [attr.datetime]="entry.occurredUtc">
            {{ formatWhen(entry.occurredUtc) }}
          </time>
        </div>

        <div class="audit-activity__meta">
          <span>{{ entry.actorDisplayName }}</span>
          <span *ngIf="entryMeta(entry)">{{ entryMeta(entry) }}</span>
          <span *ngIf="entry.outcome">{{ formatCode(entry.outcome) }}</span>
        </div>

        <div *ngIf="entry.changedPaths.length > 0" class="audit-activity__changes" aria-label="Changed fields">
          <span *ngFor="let path of entry.changedPaths" class="audit-activity__chip">{{ formatCode(path) }}</span>
        </div>

        <details *ngIf="entry.requestPath" class="audit-activity__path"><summary>Request details</summary>{{ entry.requestPath }}</details>
      </li>
    </ol>
  </ng-container>
</ng-template>
